module.exports = __webpack_public_path__ + "static/media/Database.020d287e.svg";